import React, { useEffect } from 'react';
import Layout from '../components/Layout';
import BannerSectionComponent from '../components/Sections/BannerSection';
import InfoSectionComponent from '../components/Sections/InfoSection';
import PartnerSectionComponent from '../components/Sections/PartnerSection';
import CalculatorSectionComponent from '../components/Sections/CalculatorSection';
import StoreSectionComponent from '../components/Sections/StoreSection';
import { useRegister } from '../hooks/register';
import { useModal } from '../hooks/modal';
import { stepsKeys } from './register';

const IndexPage: React.FC = () => {
  const { step, handleStep, clearData } = useRegister();
  const { handleModal } = useModal();

  useEffect(() => {
    if (step === 'registerSuccess') {
      handleStep('privatePolicy');
      handleModal({ isOpen: true, action: 'signup' });
    } else {
      clearData();
      handleStep(stepsKeys[0]);
    }
  }, []);

  return (
    <Layout navbarOff={false} footerOff={false}>
      <BannerSectionComponent />
      <InfoSectionComponent />
      <StoreSectionComponent />
      <PartnerSectionComponent />
      <CalculatorSectionComponent />
    </Layout>
  );
};

export default IndexPage;
